import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Notificar } from "../../Comunes/Notificador";

function ModificarCuotaAtrasadaModal({ cuotaAtrasada, actualizarDiasAtraso }) {
  const [show, setShow] = useState(false);
  const [cuotaAtrasadaLocal, setCuotaAtrasadaLocal] = useState(cuotaAtrasada);

  

  const handleClose = () => {
    setCuotaAtrasadaLocal(cuotaAtrasada);
    setShow(false);
  };

  const handleShow = () => setShow(true);

  const handleSubmit = async (event) => {
    event.preventDefault();

    cuotaAtrasadaLocal.tipoAccion = "M";
    cuotaAtrasadaLocal.diasAtrasoPropuesto = Number(
      cuotaAtrasadaLocal.diasAtrasoPropuesto
    );

    if (!datosValidos()) {
      return;
    }

    actualizarDiasAtraso(cuotaAtrasadaLocal);
    handleClose();
  };

  function datosValidos() {
    if (
      cuotaAtrasadaLocal.diasAtrasoPropuesto ===
      cuotaAtrasadaLocal.diasAtrasoReportado
    ) {
      Notificar(
        "error",
        "Los días de atraso propuestos son iguales a los días de atraso reportados."
      );
      return false;
    }

    return true;
  }

  return (
    <>
      <button
        className="btn btn-outline-primary btn-xs"
        title="Modificar Días de Atraso"
        onClick={handleShow}
      >
        <i className="fas fa-edit"></i>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Modificar Días de Atraso</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            {cuotaAtrasadaLocal.numeroCuotaAtrasada === 1 ? (
              <div className="alert alert-info border-left-info">
                <b>Nota: </b>Por ser número de cuota "1", el valor propuesto se
                aplicará también para los días de atraso de las cuentas por
                cobrar relacionadas al periodo y a la operación de esta cuota
                atrasada.
              </div>
            ) : null}

            <div className="form-group">
              <label htmlFor="diasAtraso">Días de Atraso Propuestos</label>
              <Form.Control
                type="number"
                className="form-control"
                name="diasAtraso"
                id="diasAtraso"
                min="0"
                value={cuotaAtrasadaLocal.diasAtrasoPropuesto ?? ""}
                onChange={(e) =>
                  setCuotaAtrasadaLocal({
                    ...cuotaAtrasadaLocal,
                    diasAtrasoPropuesto: e.target.value,
                  })
                }
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Confirmar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default ModificarCuotaAtrasadaModal;
